import { render } from "./Hinamori2.vue?vue&type=template&id=2159b47c&scoped=true"
import script from "./Hinamori2.vue?vue&type=script&lang=js"
export * from "./Hinamori2.vue?vue&type=script&lang=js"

import "./Hinamori2.vue?vue&type=style&index=0&id=2159b47c&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2159b47c"]])

export default __exports__